import React from 'react';
import styled from 'styled-components';

const StyledDivTableRow = styled.div`
  display: table-row;
`;

const StyledTableCell = styled.div`
  display: table-cell;
`;

const StyledDiv = styled.div`
  align-items: center;
  color: #333;
  display: flex;
  font-size: 14px;
  font-weight: bold;
  justify-content: center;
  padding: ${(props: { isWide: boolean }) =>
    props.isWide ? '75px 0' : '29px 0px 57px 0px'};
  ${(props: { isWide: boolean }) =>
    props.isWide
      ? `border-top: 1px solid #ebebeb;
      display: -ms-flexbox;
      -ms-flex-align: center;
      -ms-flex-pack: center;`
      : ``}
`;

interface Props {
  isWide: boolean;
}

export const InquiryListNotFound = (props: Props) => {
  const { isWide } = props;
  const NOT_FOUND_MESSAGE = '表示可能なお問い合わせはありません';

  return isWide ? (
    <StyledDivTableRow>
      <StyledTableCell>
        <StyledDiv isWide={isWide}>
          <p>{NOT_FOUND_MESSAGE}</p>
        </StyledDiv>
      </StyledTableCell>
    </StyledDivTableRow>
  ) : (
    <StyledDiv isWide={isWide}>
      <p>{NOT_FOUND_MESSAGE}</p>
    </StyledDiv>
  );
};
